import { SET_QUESTION, RESET_QUESTION } from '../constants/ActionTypes';

const loading = (state = null, action) => {
  switch (action.type) {
    case SET_QUESTION:
      return action.questionObject;
    case RESET_QUESTION:
      return null;
    default:
      return state;
  }
}

export default loading;



// WEBPACK FOOTER //
// ./src/reducers/question.js